import { Route, Redirect, Switch } from "react-router-dom";
import GestaoCategoriaAtendimento from "../../Components/Menu/GeralTab/subnavs/GestaoCadastro/CategoriaAtendimento";
import EditarCategoriaAtendimento from "../../Components/Menu/GeralTab/subnavs/GestaoCadastro/CategoriaAtendimento/EditarCategoria";
import ConfiguracaoGeral from "../../Components/Menu/GeralTab/subnavs/GestaoCadastro/ConfiguracaoGeral";
import EmailConta from "../../Components/Menu/GeralTab/subnavs/GestaoCadastro/ConfiguraçãoDeEmail/EmailConta";
import { useUserInfor } from "../../Context/User";
import AgendaAssistenciaTecnica from "../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica";
import AtributosEtapa from "../../Pages/Geral/AtributosEtapa";
import Dashboard from "../../Pages/Geral/Dashboard";
import GestaoStatusEtapa from "../../Pages/Geral/GestaoStatusEtapa";
import GestaoTemplates from "../../Pages/Geral/GestaoTemplates";
import Grupos from "../../Pages/Geral/Grupos";
import GestaoDeNotificacoes from "../../Pages/Geral/Notificacao";

import Usuarios from "../../Pages/Geral/Usuarios";
import { mostrarNavDeTela } from "../../Validations/UsuarioTela";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import ConfigurarTemplates from "../../Pages/Geral/GestaoTemplates/EditarTemplates";
import InformacoesOrganizacao from "../../Pages/Geral/InformacoesOrganizacao";
import CadastrarCliente from "../../Pages/Geral/GestaoClientes/CadastrarCliente";
import RegistraVenda from "../../Pages/Geral/RegistroVenda";
import GestaoProdutos from "../../Pages/Geral/GestaoProdutos";
import CadastraEEditaVenda from "../../Pages/Geral/RegistroVenda/CadastraEEditaVenda";
import { BlacklistEmail } from "../../Pages/Geral/Triagem/BlacklistEmail";
import CadastrarProduto from "../../Pages/Geral/GestaoProdutos/CadastrarProduto";
import EditarProduto from "../../Pages/Geral/GestaoProdutos/EditarProduto";
import ListagemFormulariosGestaoProdutos from "../../Pages/Geral/GestaoProdutos/FormulariosProduto/ListagemFormulariosGestaoProdutos";
import TodosAtendimentos from "../../Pages/Geral/GestaoClientes/TodosAtendimentos";
import Boards from "../../Pages/AtendimentoCliente/Atendimento/Boards";
import GestaoTipoParcelas from "../../Pages/Vendas/TiposDeParcelas";
import BuscaDeClientesUau from "../../Pages/Geral/BuscaDeClientesUau";
import ExecutarETL from "../../Pages/Geral/ExecutarETL";
import GestaoLogsControleReparo from "../../Pages/Geral/GestaoLogsControleReparo";
import GestaoFeriados from "../../Pages/Geral/GestaoFeriados";

export default function RotasGeral() {
    const { UserInfor } = useUserInfor();

    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.DASHBOARD.DS_PATH}
                component={Dashboard}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_GRUPOS.DS_PATH}
                component={Grupos}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_GRUPOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_USUARIOS.DS_PATH}
                component={Usuarios}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_USUARIOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CONFIG_EMAIL.DS_PATH}
                exact
                component={EmailConta}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.CONFIG_EMAIL.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CONFIG_GERAL.DS_PATH}
                exact
                component={ConfiguracaoGeral}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_USUARIOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CADASTRAR_CLIENTE.DS_PATH}
                exact
                component={CadastrarCliente}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.CADASTRAR_CLIENTE.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.DS_PATH}
                exact
                component={GestaoProdutos}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.FORMULARIOS_PRODUTOS.DS_PATH}
                exact
                component={ListagemFormulariosGestaoProdutos}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.FORMULARIOS_PRODUTOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.LISTAGEM.DS_PATH}
                exact
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.LISTAGEM.ID_TELA}
                component={RegistraVenda}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.REGISTRAR.DS_PATH}
                exact
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.REGISTRAR.ID_TELA}
                component={CadastraEEditaVenda}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.EDITAR.DS_PATH}
                exact
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.EDITAR.ID_TELA}
                component={CadastraEEditaVenda}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.GESTAO.DS_PATH}
                exact
                component={GestaoCategoriaAtendimento}
                isPrivate
                idTela={
                    ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.GESTAO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.EDITAR.DS_PATH}
                exact
                component={EditarCategoriaAtendimento}
                isPrivate
                idTela={
                    ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.EDITAR.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.NOTIFICACOES.DS_PATH}
                exact
                component={GestaoDeNotificacoes}
                isPrivate
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_TEMPLATES.DS_PATH}
                exact
                component={GestaoTemplates}
                isPrivate
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_FERIADOS.DS_PATH}
                exact
                component={GestaoFeriados}
                isPrivate
            />
            <PrivatedRoute
                path={
                    "/Geral/GestaoTemplates/ConfigurarTemplates/:idDocumentoTemplate"
                }
                exact
                component={ConfigurarTemplates}
                isPrivate
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.BLACKLIST.DS_PATH}
                component={BlacklistEmail}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.BLACKLIST.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.CADASTRO_PRODUTO.DS_PATH}
                component={CadastrarProduto}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.CADASTRO_PRODUTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.EDITAR_PRODUTO.DS_PATH}
                component={EditarProduto}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.EDITAR_PRODUTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.AGENDA.DS_PATH}
                component={AgendaAssistenciaTecnica}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.AGENDA.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.BOARD_DEVOPS.DS_PATH}
                component={Boards}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.BOARD_DEVOPS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.BUSCA_DE_CLIENTES_UAU.DS_PATH}
                component={BuscaDeClientesUau}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.BUSCA_DE_CLIENTES_UAU.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.EXECUTAR_ETL.DS_PATH}
                component={ExecutarETL}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.EXECUTAR_ETL.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_LOGS_CONTROLE_REPARO.DS_PATH}
                component={GestaoLogsControleReparo}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_LOGS_CONTROLE_REPARO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.ATRIBUTOS_ETAPA.DS_PATH}
                component={AtributosEtapa}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.ATRIBUTOS_ETAPA.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.INFORMACOES_ORGANIZACAO.DS_PATH}
                component={InformacoesOrganizacao}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.INFORMACOES_ORGANIZACAO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.STATUS_ETAPA.DS_PATH}
                component={GestaoStatusEtapa}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.STATUS_ETAPA.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_ATENDIMENTOS.DS_PATH}
                component={TodosAtendimentos}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_ATENDIMENTOS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.GERAL.TELAS.GESTAO_TIPO_PARCELAS.DS_PATH}
                component={GestaoTipoParcelas}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_TIPO_PARCELAS.ID_TELA}
            />

            <Route path={ACESSOS.GERAL.DS_BASE_URL} exact>
                {mostrarNavDeTela(
                    ACESSOS.GERAL.TELAS.DASHBOARD.ID_TELA,
                    UserInfor?.TELAS ?? []
                ) && <Redirect to={ACESSOS.GERAL.TELAS.DASHBOARD.DS_PATH} />}
            </Route>
        </Switch>
    );
}
